import React, { useState } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Home from "./components/Home";
import "../src/css/style.css";
import "../src/css/404-style.css";
import "../src/css/user-dashboard-style.css";
import "../src/css/responsive-dashboard.css";
import "../src/css/slick.css";
import "../src/css/rtlstyle.css";
import "./i18n";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
// import '../src/js/Script'
import Login from "./components/public/Login";
import Signup from "./components/public/Signup";
import Userdeshboard from "./components/authmodule/deshboard/Userdeshboard";
import Dashboarddeposit from "./components/authmodule/deshboard/Dashboarddeposit";
import Accountprofile from "./components/authmodule/deshboard/Accountprofile";
import Analytics from "./components/authmodule/deshboard/Analytics";
import Marketdashboard from "./components/authmodule/deshboard/Marketdashboard";
import Supportdashboard from "./components/authmodule/deshboard/Supportdashboard";
import Reviews from "./components/Reviews";
import Regulation from "./components/Regulation";
import Termsandconditions from "./components/Termsandconditions";
import Amlandkycpolicy from "./components/Amlandkycpolicy";
import Privacypolicy from "./components/Privacypolicy";
import Paymentpolicy from "./components/Paymentpolicy";
import Informationdisclosure from "./components/Informationdisclosure";
import Setting from "./components/authmodule/deshboard/Setting";
import { useEffect, useRef } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Forgotpassword from "./components/public/Forgotpassword";
import Resetpassword from "./components/public/Resetpassword";
import Supporttiket from "./components/authmodule/deshboard/Supporttiket";
import About from "./components/About";
import Blogs from "./components/bolgs/Blogs";
import Blogdetals from "./components/bolgs/Blogdetals";
import PostCategory from "./components/bolgs/PostCategory";
import Contacts from "./components/Contacts";
import TwitterCallback from "./components/public/TwitterCallback";
import useGlobalButtonSound from "./components/common/useGlobalButtonSound";
import clickSound from "./sounds/clicksound.mp3";
import { callApi } from "./components/common/API/Api";
import StockChart from "./components/authmodule/deshboard/Demodashboard";
import Blockpage from "./components/public/Blockpage";
import { NotificationProvider } from "./components/common/Notification";
import { NotificationProviderfordashboard } from "./components/common/DashboardNotification";
import { WebSocketProvider } from "./components/common/API/WebSocketProvider";
import Error from "./components/public/Error";
import Closeaccount from "./components/authmodule/deshboard/Closeaccount";
import Accountrestore from "./components/authmodule/deshboard/Accountrestore";
import Success from "./components/common/Success";
import Faied from "./components/common/Faied";
import Iosguide from "./components/Iosguide";
import { HelmetProvider } from "react-helmet-async";
import Androidguide from "./components/Androidguide";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { getBaseUrl } from "./components/common/BaseUrl";
import LanguageRedirect from "./components/common/LanguageRedirect";
import Userverify from "./components/authmodule/deshboard/commonmodal/Userverify";
function App() {
  const [soundEnabled, setSoundEnabled] = useState(false);
  useGlobalButtonSound(clickSound, soundEnabled);
  const token = localStorage.getItem("token");
  const getlid = localStorage.getItem("lid");
  // let base_url = process.env.REACT_APP_BASE_URL;
  let base_url = getBaseUrl();
  const cursorRef = useRef(null);
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (cursorRef.current) {
        cursorRef.current.style.top = `${e.pageY - 10}px`;
        cursorRef.current.style.left = `${e.pageX - 10}px`;
      }
    };

    const handleClick = () => {
      if (cursorRef.current) {
        cursorRef.current.classList.add("expand");
        setTimeout(() => {
          cursorRef.current.classList.remove("expand");
        }, 500);
      }
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("click", handleClick);
    };
  }, []);
  const location = window.location;
  const pathSegments = location.pathname.split("/");
  useEffect(() => {
    if (pathSegments?.length) {
      if (pathSegments[3] === "twitter" && pathSegments[4] === "") {
        window.location.href = `${base_url}login`;
      }
    }
  }, [pathSegments]);
  const searchParams = new URLSearchParams(location.search);
  const lid = searchParams.get("lid");
  useEffect(() => {
    if (lid) {
      if (lid && getlid !== lid) {
        reffercount(lid);
      }
    } else {
      localStorage.setItem("lid", "");
    }
  }, [lid]);
  useEffect(() => {
    const restrictedPaths = [
      "userdashboard",
      "userdashboarddeposit",
      "accounthistory",
      "analytics",
      "marketdashboard",
      "supportdashboard",
      "setting",
    ];
    if (!token && restrictedPaths.includes(pathSegments[1])) {
      window.location.href = `${base_url}login`;
    }
  }, [token]);
  const path = window.location.pathname;
  // useEffect(() => {
  //   const queryString = window.location.search;
  //   const urlParams = new URLSearchParams(queryString);

  //   const tokenemail = urlParams.get("token");
  //   if (tokenemail) {
  //     localStorage.setItem("token", tokenemail);
  //     window.location.href = `${base_url}userdashboard`;
  //   }
  // }, []);
  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );

    const tooltipList = tooltipTriggerList.map((tooltipTriggerEl) => {
      const tooltip = new window.bootstrap.Tooltip(tooltipTriggerEl, {
        trigger: "hover", // ✅ only hover, no click or touch
        popperConfig: (defaultBsPopperConfig) => defaultBsPopperConfig,
      });

      // Extra safety: force hide on mouse leave
      tooltipTriggerEl.addEventListener("mouseleave", () => {
        tooltip.hide();
      });

      return tooltip;
    });

    return () => {
      tooltipList.forEach((tooltip) => tooltip.dispose());
    };
  }, []);
  useEffect(() => {
    const langCode = JSON.parse(localStorage.getItem("langcode"))?.Code || "en";
    document.body.classList.add(`lang-${langCode}`);
  }, []);
  useEffect(() => {
    const handleStorageChange = () => {
      const langCode =
        JSON.parse(localStorage.getItem("langcode"))?.Code || "en";
      document.body.classList.remove(`lang-${langCode}`, "lang-ar");
      document.body.classList.add(`lang-${langCode}`);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  const reffercount = async (lid) => {
    try {
      let postdata = { referred_id: lid };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await callApi(formData, `api/reffer/count`, "POST");
      if (res?.data?.success) {
        localStorage.setItem("lid", lid);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  //   useEffect(() => {
  //     if (lid && getlid !== lid) {
  //         reffercount(lid);
  //     }
  // }, [lid]);
  function ClearIntervalOnRouteChange() {
    const location = useLocation();

    useEffect(() => {
      // Whenever the path changes, clear the global interval
      if (window.interval) {
        clearInterval(window.interval);
        console.log(
          "✅ Interval cleared due to route change:",
          location.pathname,
        );
      }
    }, [location.pathname]);

    return null; // this component only handles cleanup
  }
  useEffect(() => {
    const bs = window.bootstrap;
    if (!bs) return;

    let addedFakeState = false;

    // ✅ When modal opens
    const handleModalShown = () => {
      if (!addedFakeState) {
        // window.history.pushState({ modalOpen: true }, "");
        const currentState = window.history.state || {};
        const newState = { ...currentState, modalOpen: true }; // ✅ merge
        window.history.pushState(newState, "");
        addedFakeState = true;
      }
    };

    // ✅ When modal closes (DO NOT REFRESH PAGE)
    const handleModalHidden = () => {
      if (addedFakeState) {
        // window.history.replaceState(null, ""); // ✅ remove fake state WITHOUT reload
        addedFakeState = false;
      }

      // ✅ also clean backdrop if needed
      document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
      document.body.classList.remove("modal-open");
    };

    // ✅ back button
    const handlePopState = () => {
      const modalEl = document.querySelector(".modal.show");

      if (modalEl) {
        const instance = bs.Modal.getOrCreateInstance(modalEl);
        instance.hide(); // ✅ close modal instead of going back
        return;
      }

      // ✅ if no modal is open → allow normal back
    };

    document.addEventListener("shown.bs.modal", handleModalShown);
    document.addEventListener("hidden.bs.modal", handleModalHidden);
    window.addEventListener("popstate", handlePopState);

    return () => {
      document.removeEventListener("shown.bs.modal", handleModalShown);
      document.removeEventListener("hidden.bs.modal", handleModalHidden);
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
  const withCaptcha = (Component) => {
    return function WrappedComponent() {
      return (
        <GoogleReCaptchaProvider reCaptchaKey="6LfqE3IsAAAAACpMn28fB59ZEPentM8ckYyKEBQK">
          <Component />
        </GoogleReCaptchaProvider>
      );
    };
  };
  const SignupWithCaptcha = withCaptcha(Signup);
  const supportedLangs = ["en", "ru", "ar", "pt", "es", "fr", "ko"];

  const getLang = () => {
    const savedLang = window.location.pathname.split("/")[1];
    const browserLang = navigator.language.slice(0, 2);

    if (supportedLangs.includes(savedLang)) return savedLang;
    if (supportedLangs.includes(browserLang)) return browserLang;

    return "en";
  };
  const lang = getLang();

  return (
    <React.Fragment>
      <HelmetProvider>
        <NotificationProviderfordashboard>
          <NotificationProvider>
            <WebSocketProvider>
              <Router>
                <ClearIntervalOnRouteChange />

                <Routes>
                  {/* ✅ redirect root → /en */}
                  {/* <Route
                    path="/"
                    element={<Navigate to={`/${lang}`} replace />}
                  /> */}
                  <Route
                    path="/:anything"
                    element={
                      <Navigate
                        to={`/${lang}/${window.location.pathname.slice(1)}`}
                        replace
                      />
                    }
                  />
                  {/* ✅ redirect specific routes */}
                  <Route
                    path="/login"
                    element={<Navigate to={`/${lang}/login`} replace />}
                  />
                  <Route
                    path="/signup"
                    element={
                      <Navigate
                        to={`/${lang}/signup${window.location.search}`}
                        replace
                      />
                    }
                  />

                  {/* ✅ catch ALL non-lang paths */}
                  <Route
                    path="/:anything"
                    element={
                      <Navigate
                        to={`/${lang}/${window.location.pathname.slice(1)}`}
                        replace
                      />
                    }
                  />

                  {/* ✅ ALL LANG ROUTES */}
                  <Route path="/:lang">
                    <Route index element={<Home />} />

                    <Route
                      path="login/twitter/:token"
                      element={<TwitterCallback />}
                    />
                    <Route path="login" element={<Login />} />
                    <Route path="signup" element={<SignupWithCaptcha />} />
                    <Route path="1plat/success" element={<Success />} />
                    <Route path="1plat/fail" element={<Faied />} />
                    <Route path="forgotpassword" element={<Forgotpassword />} />
                    <Route
                      path="resetpassword/:email/:token"
                      element={<Resetpassword />}
                    />

                    <Route path="reviews" element={<Reviews />} />
                    <Route path="regulation" element={<Regulation />} />
                    <Route path="instruction-ios" element={<Iosguide />} />
                    <Route
                      path="instruction-android"
                      element={<Androidguide />}
                    />
                    <Route
                      path="termsandconditions"
                      element={<Termsandconditions />}
                    />
                    <Route path="about" element={<About />} />
                    <Route path="contacts" element={<Contacts />} />
                    <Route
                      path="amlandkycpolicy"
                      element={<Amlandkycpolicy />}
                    />
                    <Route path="privacypolicy" element={<Privacypolicy />} />
                    <Route path="paymentpolicy" element={<Paymentpolicy />} />
                    <Route
                      path="informationdisclosure"
                      element={<Informationdisclosure />}
                    />
                    <Route path="blockpage" element={<Blockpage />} />

                    <Route path="blog" element={<Blogs />} />
                    <Route path="blogdetals" element={<Blogdetals />} />
                    <Route path="postcategory" element={<PostCategory />} />

                    {/* DASHBOARD */}
                    <Route
                      path="userdashboard"
                      element={
                        <Userdeshboard
                          setSoundEnabled={setSoundEnabled}
                          soundEnabled={soundEnabled}
                        />
                      }
                    />

                    <Route
                      path="demodashboard"
                      element={
                        <StockChart
                          setSoundEnabled={setSoundEnabled}
                          soundEnabled={soundEnabled}
                        />
                      }
                    />

                    <Route path="Closeaccount" element={<Closeaccount />} />
                    <Route path="restoreaccount" element={<Accountrestore />} />
                      <Route path="userverify" element={<Userverify />} />
                    <Route
                      path="userdashboarddeposit"
                      element={<Dashboarddeposit />}
                    />
                    <Route path="accounthistory" element={<Accountprofile />} />
                    <Route path="analytics" element={<Analytics />} />
                    <Route
                      path="marketdashboard"
                      element={<Marketdashboard />}
                    />
                    <Route
                      path="supportdashboard"
                      element={<Supportdashboard />}
                    />
                    <Route
                      path="supportdashboard/:ticket_id/:id"
                      element={<Supporttiket />}
                    />

                    <Route
                      path="setting"
                      element={
                        <Setting
                          setSoundEnabled={setSoundEnabled}
                          soundEnabled={soundEnabled}
                        />
                      }
                    />

                    {/* ✅ ERROR PAGE */}
                    <Route path="*" element={<Error />} />
                  </Route>
                  <Route path="*" element={<LanguageRedirect />} />
                </Routes>
              </Router>

              <ToastContainer />
            </WebSocketProvider>
          </NotificationProvider>
        </NotificationProviderfordashboard>
      </HelmetProvider>
    </React.Fragment>
  );
}

export default App;
